<template>
  <div>
  <v-row class="pt-0">
    <v-col cols="12" sm="6" md="6" lg="4" class="pt-0 pb-0">
      <span class="head-search-text">ค้นหา</span>
      <v-autocomplete
        v-model="searchName"
        :items="searchList"
        item-text="name"
        item-value="_id"
        outlined
        dense
        clearable
        class="mt-2"
        placeholder="ค้นหาได้จากชื่อ tag"
        no-data-text="ไม่พบข้อมูล"
        @change="searchFilterData(), page=1"
        @click:clear="searchName='', searchFilterData(), page=1"
      >
      <template v-slot:append>
        <img width="18" height="18" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @click="searchFilterData(), page=1">
      </template>
      </v-autocomplete>
    </v-col>
    <!-- <v-col cols="12" sm="6" md="6" lg="4" class="pt-0 pb-0">
      <span class="head-search-text">ค้นหาชื่อ Tag</span>
      <v-select
        v-model="selectTagList"
        :items="tagList"
        outlined
        dense
        clearable
        class="mt-2"
        placeholder="ค้นหาได้จากชื่อ Tag"
        no-data-text="ไม่พบข้อมูล"
        @change="searchFilterData(), page=1"
      >
      </v-select>
    </v-col> -->
    <v-spacer/>
    <div class="pt-0 d-flex align-end" style="padding-bottom: 15px; padding-right: 12px;">
      <v-btn
        outlined
        class="button-color ra-button-employee"
        dark
        @click="gotocreate()"
      >
        <v-icon left dark color="#fff" size="14px">mdi-plus</v-icon>
        <span class="ra-text-in-button-employee">
          เพิ่ม Tag
        </span>
      </v-btn>
    </div>
  </v-row>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import {
// getSelectApproveRequestCompany
} from '@/API/API'
// import axios from 'axios'
export default {
  name: 'filter-workgroup',
  props: {
    mode: String
  },
  data () {
    return {
      tapData: ['', 'waiting', 'pending', 'approve', 'reject'],
      tapSelect: 0,
      searchName: '',
      keywordRequestNo: '',
      keywordPosition: [],
      keywordType: [],
      keywordCompanyName: [],
      keywordGroupCompanyName: [],
      searchList: [],
      itemPosition: [],
      itemCompanyName: [],
      itemGroupCompanyName: [],
      itemRequestType: [],
      tagList: [],
      businessType: '',
      selectTagList: '',
      filterData: {
        tag: '',
        approveType: this.mode,
        limit: 50,
        page: 1
      },
      selectData: {
        companyName: [],
        requestType: [],
        status: [
          { value: 'pending', text: 'รอการอนุมัติ' },
          { value: 'approve', text: 'อนุมัติ' },
          { value: 'reject', text: 'ปฏิเสธอนุมัติ' }
        ],
        statusAct: [
          { value: 'pending', text: 'รอการรับทราบ' },
          { value: 'acknowledge', text: 'รับทราบ' }
        ]
      },
      menu: false,
      menu1: false,
      datesUpdateAt: [],
      datesCreateAt: [],
      menu2: false,
      createAt: '',
      updateAt: '',
      totalAll: 0,
      totalWaiting: 0,
      totalPending: 0,
      totalApproved: 0,
      totalRejected: 0,
      allowBtnApprove: false,
      allowBtnReject: false,
      textBtnOk: this.mode === 'approve' ? 'Approve' : 'Acknowledge',
      textBtnNO: this.mode === 'approve' ? 'Reject' : 'Unacknowledge',
      approveRole: localStorage.approveRole,
      itemBusiness: []
    }
  },
  watch: {
    // approveRole () { return localStorage.approveRole }
    datesUpdateAt: function (val) {
      if (this.datesUpdateAt[0] !== undefined && this.datesUpdateAt[1] !== undefined) {
        this.updateAt = this.datesUpdateAt[0] + ' ' + this.datesUpdateAt[1]
        // this.searchFilterData()
      }
    },
    datesCreateAt: function (val) {
      if (this.datesCreateAt[0] !== undefined && this.datesCreateAt[1] !== undefined) {
        this.createAt = this.datesCreateAt[0] + ' ' + this.datesCreateAt[1]
        // this.searchFilterData()
      }
    }
  },
  computed: {
    // approveRole () { return localStorage.approveRole }
    dateRangeTextUpdate () {
      const chkDate = ''
      if (this.datesUpdateAt.length !== 0) {
        return this.datesUpdateAt.join(' ~ ')
      } else {
        return chkDate
      }
    },
    dateRangeTextCreate () {
      const chkDate = ''
      // return this.datesCreateAt.join(' ~ ')
      if (this.datesCreateAt.length !== 0) {
        return this.datesCreateAt.join(' ~ ')
      } else {
        return chkDate
      }
    }
  },
  async created () {
    await this.searchFilterData()
  },
  mounted () {
    // EventBus.$on('getPosition', this.getSelectData)
    EventBus.$on('getFilterฺTag', this.getSelectValue)
    EventBus.$on('updateTotalCom', this.updateTotal)
    EventBus.$on('setApproveRole', this.setApproveRole)
  },
  beforeDestroy () {
    EventBus.$off('manageApproveComSearch')
    EventBus.$off('updateTotalCom')
    EventBus.$off('setApproveRole')
  },
  methods: {
    gotocreate () {
      // this.$router.push('managebusines/create')
      this.$router.push({
        name: 'manageTransferrolecreate',
        params: {
          type: 'new',
          id: ''
        }
      })
    },
    async setApproveRole () {
      this.approveRole = localStorage.approveRole
      this.page = 1
      this.resetFilterData()
      // await this.getSelectData()
      await this.searchFilterData()
    },
    updateTotal (value) {
      this.totalAll = value.totalAll
      this.totalPending = value.totalPending
      this.totalApproved = value.totalApproved
      this.totalRejected = value.totalRejected
      this.totalWaiting = value.totalWaiting
    },
    getSelectValue (filter) {
      this.searchList = filter.result[0].tag
      // this.itemBusiness = filter.result.businessTypeList
    },
    resetUpdateDate () {
      this.updateAt = ''
      this.datesUpdateAt = []
      this.searchFilterData(1, 15)
    },
    resetCreateDate () {
      this.createAt = ''
      this.datesCreateAt = []
      this.searchFilterData(1, 15)
    },
    resetFilterData () {
      this.selectTagList = ''
      this.filterData = {
        tag: '',
        approveType: this.mode
      }
      this.searchFilterData(1, 15)
    },
    searchFilterData () {
      this.filterData = {
        tag: this.searchName,
        role: this.approveRole
      }
      EventBus.$emit('tagSearch', this.filterData)
    },
    setObjFilter (data) {
      return (typeof data === 'string') ? [data] : data
    },
    removeChip (item) {
      const index = this.keywordType.indexOf(item.requestTypeEng)
      if (index >= 0) this.keywordType.splice(index, 1)
    }
  }
}
</script>

<style>
.v-input__slot {
  align-items: center;
  color: inherit;
  display: flex;
  margin-bottom: 0px !important;
  min-height: inherit;
  position: relative;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  width: 100%;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}

.v-text-field__details {
  min-height: 0px !important;
}

.theme--light.v-text-field--outlined > .v-input__control > .v-input__slot {
  /* font-family: 'Sarabun', sans-serif; */
  font-family: 'Sarabun', sans-serif !important;
  font-weight: normal;
  font-size: 14px;
}

.v-menu__content {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}

.filter-chip_department {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
  font-size: 14px;
  color: #fff;
}

.filter-title-textfield {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
  color: #000;
}
.ra-button-employee {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 9px 24px;

  /* position: absolute; */
  width: 157px;
  height: 36px;

  /* Color / Primary / Default */

  background: #3776E9;
  border-radius: 4px;
}
.ra-text-in-button-employee {
  font-family: 'Sarabun', sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
}
</style>
